import { Button, Dialog, DialogActions, DialogContent, IconButton, styled, Typography } from '@mui/material';
import { CheckIcon } from 'lucide-react';
import dataUpdatedIcon from '../../assets/images/data-updated-icon.svg';

const DialogTitleWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  marginTop: '36px',
});

interface CaseDataUpdateModalProps {
  open: boolean;
  onKeep: () => void;
  onUpdate: () => void;
  onDone: () => void;
  isUpdating?: boolean;
  isUpdateFinished?: boolean;
}

export function CaseDataUpdateModal({
  open,
  onKeep,
  onUpdate,
  onDone,
  isUpdating = false,
  isUpdateFinished,
}: CaseDataUpdateModalProps) {
  return (
    <Dialog open={open} onClose={onDone} sx={{ zIndex: 998 }} maxWidth='xs' fullWidth>
      <DialogTitleWrapper>
        {isUpdateFinished ? (
          <IconButton size='large' disabled sx={{ background: '#C6F6D5 !important', color: '#38A169 !important' }}>
            <CheckIcon size={36} strokeWidth={2.5} />
          </IconButton>
        ) : (
          <IconButton size='large' disabled sx={{ background: '#FEEBCB !important', color: '#ED8936 !important' }}>
            <img src={dataUpdatedIcon} alt='Data updated icon' width={36} height={36} />
          </IconButton>
        )}
        {isUpdateFinished ? (
          <Typography sx={{ fontSize: '24px', fontWeight: 'bold', color: 'primary.main' }}>Update complete</Typography>
        ) : (
          <Typography sx={{ fontSize: '24px', fontWeight: 'bold', color: 'primary.main' }}>Data Updated</Typography>
        )}
      </DialogTitleWrapper>
      <DialogContent sx={{ marginBottom: '24px' }}>
        {isUpdateFinished ? (
          <Typography sx={{ textAlign: 'center', fontSize: '14px' }}>
            The case data has been successfully updated.
          </Typography>
        ) : (
          <Typography sx={{ textAlign: 'center', fontSize: '14px' }}>
            The case data has been updated. You can choose to sync the new data or keep the existing case data.
          </Typography>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: isUpdateFinished ? 'center' : 'space-between',
          paddingX: '20px',
          paddingBottom: '20px',
        }}
      >
        {isUpdateFinished ? (
          <Button sx={{ width: 'calc(50% - 10px)' }} disableElevation variant='outlined' onClick={onDone}>
            Done
          </Button>
        ) : (
          <>
            <Button
              sx={{ width: 'calc(50% - 10px)' }}
              disableElevation
              variant='outlined'
              onClick={onKeep}
              disabled={isUpdating}
            >
              Keep
            </Button>
            <Button
              sx={{ width: 'calc(50% - 10px)' }}
              disableElevation
              variant='contained'
              onClick={onUpdate}
              disabled={isUpdating}
            >
              {isUpdating ? 'Updating...' : 'Update'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default CaseDataUpdateModal;
